<template>
  <v-col cols="12" class="pa-0 ma-0" :style="{ height: tabBarActive ? '66vh' : '100vh' }">
      <!-- Bandeau d'alerte -->
      <div v-if="order_pending && !bannerClosed" class="warning-banner">
        ⚠️ Commande en attente / Purchase Order pending !
        <span class="close-btn" @click="bannerClosed = true">✖</span>
      </div>
    
    
    <l-map ref="map" @ready="centerMap"  :zoom="zoom" :center="center" :key="mapKey"> 
      <l-tile-layer :url="url" ></l-tile-layer>
      <l-control :position="'bottomleft'" style="background-color:white; width:130px;padding:5px; color: primary;" >
        <!-- refresh data -->
        
        <v-btn 
          :loading="loading" 
          class="toggle-btn" 
          fab 
          small 
          color="primary" 
          @click="refreshPage" 
          title="Rafraîchir la page"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <br />
        <br />
        <br />
        <v-select
          v-model="selectedDays"
          :items="periodOptions"
          style= "color: primary !important; z-index:1500" 
          label="Derniers"
          dense
          outlined
          light

          @change="getMovements()"
        ></v-select>
        <v-btn class="toggle-btn" @click="toggleNDVI" icon color="primary">
          <strong>NDVI :<v-icon>{{ tileNDVI ? "mdi-eye-off" : "mdi-eye" }}</v-icon></strong>
        </v-btn> 
        <br>
        <v-btn class="toggle-btn" @click="legende = true" icon color="primary">
          <strong>Aide</strong>
        </v-btn>      
      </l-control>
      <l-layer-group visible @ready="setZIndex">
        <l-geo-json ref="zone" :geojson="geojsonfiltered"></l-geo-json>
        <l-geo-json @click="selectZone" :geojson="geojsonWithoutSelected" :options="geojsonoption"></l-geo-json>
      </l-layer-group>            
      <l-geo-json v-if="lastMovementsComputed" :geojson="lastMovementsComputed"
        :options="geojsonoptionUserMovements"></l-geo-json>
        
        <l-geo-json
          v-for="(geojsonItem, index) in lastMovementsComputed"
          :key="index"
          :geojson="geojsonItem.coordinates"
          :options="getGeoJsonOptions(geojsonItem)"
        ></l-geo-json>
        
      <l-tile-layer v-if="tileNDVI" :opacity="1" :url="tileNDVI" layer-type="overlay" name="NDVITILE"></l-tile-layer>
      <l-draw-toolbar v-if="zoneSelected.text" ref="draw" position="topright" />
      <l-marker @click="viewSign(sign)" v-for="sign in signalements" :key="`sign${sign.id}`"
       :z-index-offset="1000"
        :lat-lng="[sign.position.coordinates[1], sign.position.coordinates[0]]">
        <l-icon :icon-size="[20, 20]" :icon-anchor="[6, 15]">
          <v-icon small color="#FF6347">mdi-alert</v-icon>
        </l-icon>
      </l-marker>
      <template v-for="warn in warnings">
        <l-marker v-if="warn.position" :key="`warning${warn.id}`"
        :z-index-offset="1000"
          :lat-lng="[warn.position.coordinates[1], warn.position.coordinates[0]]">
          <l-icon :icon-size="[20, 20]" :icon-anchor="[6, 15]">
            <v-icon small color="red">mdi-tractor</v-icon>
          </l-icon>
        </l-marker>
      </template>
      <!--
      <l-circle-marker :options="{
        fillColor: 'red',
        color: 'red',
        weight: .5,
      }" v-for="sign in signalements" :key="`signalement${sign.id}`"
        :lat-lng="[sign.position.coordinates[1], sign.position.coordinates[0]]">
      </l-circle-marker>
-->
      <l-layer-group @ready="$event.setZIndex(1000)">
        <!-- Boucle sur toutes les `protectedZones` -->
        <div v-for="(protectZone, i) in protectedZones" :key="`protectedZone${i}`">
          <!-- Si la géométrie est un `Point`, affiche une icône -->
          <l-marker
            v-if="protectZone.geometry.type === 'Point'"
            :lat-lng="[protectZone.geometry.coordinates[1], protectZone.geometry.coordinates[0]]"
            @click="selectProtectedZone(protectZone)"
          >
            <l-icon :icon-size="[15, 15]" :icon-anchor="[6, 15]">
              <v-icon small color="red">mdi-alert</v-icon>
            </l-icon>
          </l-marker>
      
          <!-- Sinon, affiche la zone normalement avec `l-geo-json` -->
          <l-geo-json
            v-else
            @click="selectProtectedZone(protectZone)"
            :geojson="protectZone"
            :options="geojsonoptionProtected"
          ></l-geo-json>
        </div>
      </l-layer-group>

    </l-map>
    <tab-bar />
      
    <v-dialog style="z-index:100000!important;" v-model="protectedZonePopup" max-width="400">
      <v-card>
        <v-card-title>
          <span class="headline">Zone protégée</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field v-model="name" :counter="20" label="Nom de la zone" required></v-text-field>
            <v-text-field v-model="description" :counter="30" label="Description" required></v-text-field>
            <v-select outlined hide-details v-model="selectedSign" :items="signtype" />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="deleteProtectedZone(); protectedZonePopup = false">Supprimer</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="protectedZonePopup = false">Annuler</v-btn>
          <v-btn color="blue darken-1" text @click="updateProtectedZone(); protectedZonePopup = false">Enregistrer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog style="z-index:100000!important;" v-model="legende" max-width="400">
      <v-card>
        <v-toolbar >
        <v-btn icon @click="legende = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Aide</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          Pour planifier, choisir une zone puis un clic sur la zone de dates.<br />
          Pour protéger une zone, choisir la zone puis la dessiner avec les outils en haut à droite  <br />      
          <ul>
            <li>Rectangle rouge : zone à protéger et ne pas faucher</li>
          <li><v-icon small color="orange">mdi-alert</v-icon> :  signalement utilisateur</li>
          <li><v-icon small color="red">mdi-tractor</v-icon> :  point où un tracteur a pénétré une zone à ne pas faucher</li>
          </ul>
        </v-card-text>
        
      </v-card>
    </v-dialog>

    <!-- view sign -->
    <v-dialog v-model="signPopup" style="z-index:100000!important;">
      <v-card v-if="signSelected">
        <v-toolbar >
          <v-btn icon @click="signPopup = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Signalement</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn icon color="success" @click="updateSign()">
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn icon color="error" @click="deleteSign()">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-img :src="`https://adp-backend.previmeteo.net/assets/${signSelected.photo}`" height="300px" contain></v-img>
        <v-card-title>
          <span class="headline">Signalement</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field v-model="signSelected.type_text" readonly :counter="10" label="Type" required></v-text-field>
            <v-text-field v-model="signSelected.comment" readonly :counter="30" label="Description" required></v-text-field>
            <v-text-field v-model="signSelected.created_at_formatted" readonly :counter="30" label="Date" required></v-text-field>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import { LMap, LTileLayer, LGeoJson, LMarker, LIcon, LControl, LLayerGroup } from 'vue2-leaflet';
import TabBar from '@/components/TabBar.vue';
import geojson from '@/assets/lfpo.json'
import { mapGetters, mapState, mapActions } from 'vuex';
import LDrawToolbar from 'vue2-leaflet-draw-toolbar';
import axios from 'axios';
export default {
  name: 'HomeView',
  components: {
    LMap,
    LTileLayer,
    LGeoJson,
    TabBar,
    LDrawToolbar,
    LMarker,
    LIcon,
    LLayerGroup,
    LControl
  },
  computed: {
    ...mapState(['zoneSelected', 'lastUserMovements', 'lastMovements']),
    ...mapGetters(['getZones','getTabBarActive']),
    tabBarActive() {
      return this.getTabBarActive; // Rendre plus lisible
    },
    lastUserMovementsComputed() {
      if (this.lastUserMovements.movement) {
        return {
          ...this.lastUserMovements?.movement?.coordinates
        }
      }
      return null
    },
    lastMovementsComputed() {
      
      if (this.lastMovements) {
        //if (this.lastMovements.movements) console.log("lastMovementsComputed ",this.lastMovements.movements[0])
        return {
          ...this.lastMovements?.movements
        }
      }
      return null
    },
    geojsonfiltered() {
      return {
        ...geojson,
        features: geojson.features.filter(feature => this.zoneSelected?.text ? feature.properties.NOMOBJET === this.zoneSelected?.text : true)
      }
    },
    geojsonWithoutSelected() {
      let zones = this.getZones
      zones = zones.filter((zone) => zone.text !== this.zoneSelected.text)
      let mergedZones = zones.map((zone) => {
        return {
          ...zone,
          ...zone.geojson
        }
      })
      return {
        ...geojson,
        features: mergedZones
      }
    }
  },
  data: () => ({
    zoom: 13,
    center: [47.413220, -1.219482],
    //url: 'https://api.mapbox.com/styles/v1/pmcom/ckeczy27y2qb91at76rmxqcdr/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoicG1jb20iLCJhIjoiY2lxajgxbHF3MDBjZWkwbWMza2pwYzFoayJ9.a1ywamqhc2BKAdxMdgcBpA',
    url: 'https://api.mapbox.com/styles/v1/pmcom/cm6xuy73o00la01sagspf8qww/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoicG1jb20iLCJhIjoiY2lxajgxbHF3MDBjZWkwbWMza2pwYzFoayJ9.a1ywamqhc2BKAdxMdgcBpA',
    tileNDVI: null,
    order_pending:true,
    bannerClosed:false,
    timeNDVI: null,
    geojson: geojson,
    name: '',
    loading: false,
    description: '',
    warnings: [],
    isActive: false,
    protectedZones: [],
    signSelected: null,
    legende: false,
    signPopup: false,
    selectedSign: false,
    signalements: [],
    protectedZonePopup: false,
    selectedProtectedZone: null,
    selectedDays: 14, // Valeur par défaut
    periodOptions: [
      { text: "24 heures", value: 1 },
      { text: "3 jours", value: 3 },
      { text: "7 jours", value: 7 },
      { text: "14 jours", value: 14 },
      { text: "28 jours", value: 28 },
    ],
    mapKey: 0, // Clé pour forcer le re-render
    signtype: [
        { text: 'Inondation', value: 'flood' },
        {
            text: 'Déchets',
            value: 'waste'
        },
        {
            text: 'Plantes invasives',
            value: 'invasible plant'
        },
        {
            text: 'Obstacle',
            value: 'obstacle'
        },
        {
            text: 'Zone inaccessible',
            value: 'accessibility'
        },
        {
            text: 'Animaux',
            value: 'animals'
        },
        
        {
            text: 'Autre',
            value: 'other'
        }
    ],
    geojsonoption: {
      style: {
        color: '#d6d6d6',
        weight: 2,
        opacity: 1,
        fillColor: '#d6d6d6',
        fillOpacity: 0.2
      }
    },
    geojsonoptionUserMovements: {
      style: {
        color: 'orange',
        weight: 4,
        opacity: 1,
        fillColor: 'orange',
        fillOpacity: 0.2
      }
    },
    geojsonoptionProtected: {
      zIndexOffset: 1000,
      style: {
        color: '#FF2D00',
        weight: 2,
        opacity: 1,
        fillColor: '#FF2D00',
        fillOpacity: 0.2
      }
    }
  }),
  methods: {
    ...mapActions(['toggleTabBar']), // Permet de modifier la valeur
    getGeoJsonOptions(geojsonItem) {
      const now = new Date();
      const movementDate = new Date(geojsonItem.last_update); // Assurez-vous que la date est dans properties
      const diffDays = Math.floor((now - movementDate) / (1000 * 60 * 60 * 24)); // Différence en jours
    
      // Définir l'intensité de l'orange en fonction de l'ancienneté
      const baseColor = 25; // Teinte orange (25° sur l'échelle HSL)
      const minLightness = 40; // Plus foncé pour les récents
      const maxLightness = 85; // Plus clair pour les anciens
      const lightness = Math.min(maxLightness, minLightness + diffDays * 7); 
    
      const color = `hsl(${baseColor}, 100%, ${lightness}%)`;
    
      return {
        style: () => ({
          color: color,  // Contour
          weight: 4,     // Épaisseur
          opacity: 1,    // Opacité du contour
          fillColor: color, // Couleur de remplissage
          fillOpacity: 0.2, // Opacité du remplissage
        }),
      };
    },
    refreshPage() {
      this.loading = true;
      setTimeout(() => {
        window.location.reload(); // Rafraîchir la page
      }, 500); // Laisse un léger délai pour une meilleure UX
    },
    toggleNDVI() {
      this.tileNDVI = !this.tileNDVI;
      if (this.tileNDVI) {
        this.initNDVI(); // Appeler initNDVI() lorsque NDVI est activé
      }
    },
    deleteSign() {
      this.$directus.items('Signalements').deleteOne(this.signSelected.id)
      this.signalements = this.signalements.filter((item) => item.id !== this.signSelected.id)
      this.signPopup = false;
      this.getSignalements();
    },
    updateSign() {
      this.$directus.items('Signalements').updateOne(this.signSelected.id, {
        state:'done'
      }).then(() => {
        this.signPopup = false
      })
    },
    async refreshData(){
      this.loading = true
      try{
        await this.getSignalements()
        await this.getWarnings()
      }catch(e){
        // console.log(e)
      }
      this.loading = false
    },
    onDrawCreated(e) {
      // console.log('draw created')
      let geojson = e.layer.toGeoJSON()
      // remove the layer from the map
      if (e.layer) this.$refs.map.mapObject.removeLayer(e.layer);
      geojson.type = "protected"
      // add entrie to directus
      this.$directus.items('ProtectedZone').createOne({
        geojson: e.layer.toGeoJSON(),
        zone: this.zoneSelected.id
      }).then((data) => {
        this.protectedZones.push({
          id: data.id,
          ...data.geojson
        })
      })
    },
    updateProtectedZone() {
      
      this.$directus.items('ProtectedZone').updateOne(this.selectedProtectedZone.id, {
        name: this.name,
        description: this.description,
        type: this.selectedSign,
      })
    },
    setZIndex(event)
    {
      event.setZIndex(100)
      //console.log('event', event)
    },
    bringToBack(event) {
      this.$nextTick(() => {
        console.log(event.bringToBack())
      })
    },
    bringToFront(event) {
      this.$nextTick(() => {
        event.bringToFront()
      })
    },
    deleteProtectedZone() {
      //console.log("deleteProtectedZone",this.selectedProtectedZone.id)
      this.$directus.items('ProtectedZone').deleteOne(this.selectedProtectedZone.id)
      this.protectedZones = this.protectedZones.filter((item) => item.id !== this.selectedProtectedZone.id)
    },
    centerMap() {
      this.$refs.map.mapObject.fitBounds(this.$refs.zone.mapObject.getBounds());
      // console.log('on draw created')
      this.$refs.map.mapObject.on('draw:created', this.onDrawCreated);
    },
    getWarnings() {
      this.$directus.items('Warnings').readByQuery({
        fields: ['*'],
        filter: {
          date_created: {
            _gte: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString() // Date actuelle - 7 jours
          }
        }
      }).then((data) => {
        this.warnings = data.data;
      });
    },
    getMovements() {
      //console.log("getMovements");
      console.log(`📡 Récupération des mouvements des ${this.selectedDays} derniers jours...`);
      // Calculez la date d'aujourd'hui moins un mois
      const nbDaysAgo = new Date();
      nbDaysAgo.setDate(nbDaysAgo.getDate() - this.selectedDays); // Soustrait 14 jours
      
      // Formattez la date au format ISO 8601 attendu par Directus
      const formattedDate = nbDaysAgo.toISOString();
      //console.log(formattedDate);
      
      this.$directus.items('Movements').readByQuery({
        fields: ['*.*'],
        limit: 1000,
        //sort: ['-date_created'],
        filter: {
          last_update: {
            _gte: formattedDate, // Filtre : date_created >= aujourd'hui - 1 mois
          },
        },
      }).then((data) => {
        console.log("movements ",data)
        this.$store.dispatch('setLastMovements', {
          movements: data.data,
        });
      });
      
    },
    getSignalements() {
      this.$directus.items('Signalements').readByQuery({
        filters: {
          zone: this.zoneSelected.id
        },
      }).then((data) => {
        // console.log(data)
        this.signalements = data.data
        this.signalements = this.signalements.map(signalement => {
            // Trouver le texte correspondant au type
            const matchedType = this.signtype.find(item => item.value === signalement.type);
        
            // Formatter la date
            const date = new Date(signalement.created_at);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const created_at_formatted = `${day}/${month}/${year} à ${hours}:${minutes}`;
        
            // Retourner l'objet enrichi
            return {
                ...signalement,
                type_text: matchedType ? matchedType.text : 'Type inconnu',
                created_at_formatted
            };
        });
        console.log(this.signalements)
      })
    },
    viewSign(sign) {
      console.log(sign)
      this.signSelected = sign
      this.signPopup = true
    },
    selectProtectedZone(e) {
      //console.log("selectProtectedZone",e)
      
      this.name = e.name
      this.description = e.description
      this.selectedSign = e.typeSign
      this.protectedZonePopup = true
      // console.log(e.layer)
      this.selectedProtectedZone = e
    },
    selectZone(e) {
      // console.log(e.layer.feature)
      if (!this.getTabBarActive) this.toggleTabBar();
      
      e.layer.bringToBack()
      this.$store.commit("setZoneSelected", this.getZones.find((zone) => zone.id === e.layer.feature.id))
      
      this.getMovements()
    },

    async initNDVI() {
      let start = this.$moment().subtract(3, 'month').unix();
      let end = this.$moment().subtract(0, 'week').unix();
      let url = `https://api.agromonitoring.com/agro/1.0/image/search?end=${end}&start=${start}&polyid=674dc3d4d444b63e981ab479&appid=28c103f6b7a9e33d8f9305ef901d3939&clouds_max=70`;
      //console.log('url agro', url);
      let data = await axios.get(url);
       //console.log(data);
      data.data.reverse();
      this.tileNDVI = data.data.find(map => map.cl < 80).tile.ndvi.replace('http', 'https');
      let timestampNDVI = data.data.find(map => map.cl < 80).dt;
      const date = new Date(timestampNDVI*1000);
      //console.log(this.tileNDVI,timestampNDVI)
      // Formater en chaîne lisible
      this.timeNDVI = date.toLocaleDateString('fr-FR');
      //console.log('timeNDVI', this.timeNDVI)
      

    },
    getProtectedZone() {
      this.$directus.items('ProtectedZone').readByQuery({
      }).then((data) => {
        this.protectedZones = data.data.map((item) => {
          //console.log("protected ",item)
          //const matchedType = this.signtype.find(it => it.value === item.type);
          return {
            id: item.id,
            name: item.name,
            description: item.description,
            typeSign: item.type,
            ...item.geojson
          }
        })
      })
    }
  },
  mounted() {
    //this.initNDVI()
    this.getWarnings();
    this.getProtectedZone();
    this.getSignalements();
    this.getMovements();
    //this.toggleNDVI();
  },
  watch: {
    zoneSelected() {
      // console.log(this.zoneSelected)
      this.$nextTick(() => {
        this.centerMap()
      })
    },
    tabBarActive() {
      this.mapKey++; // Change la clé pour recréer la carte
      },

  }
}
</script>

<style>
.leaflet-container {
  width: 100%;
  height: 100%;
  z-index: 0;
}
.toggle-btn {
  position: relative;
  top: 10px;
  left: 20px; /* Déplacement en haut à droite */
  z-index: 1000;
}

.button-container {
  display: flex;
  justify-content: center; /* Alignement horizontal */
  align-items: center;
  gap: 10px; /* Espacement entre les boutons */
}

ul.leaflet-control-toolbar.leaflet-toolbar-0.leaflet-draw-toolbar {
  border: none;
}
.warning-banner {
  background-color: #ffcc00;
  padding: 10px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  cursor: pointer;
  font-size: 18px;
}
</style>
